import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    title: $data.title,
    modelValue: $data.isDialogShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.isDialogShow = $event),
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = $event => $data.isDialogShow = false)
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options._onSubmit
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["title", "modelValue"]);
}